import { Provider as ReduxProvider } from 'react-redux'
import { render } from 'react-dom'
import React, { FC } from 'react'
import { ColorModeScript, ChakraProvider } from '@chakra-ui/react'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import theme from '../styles'
import { store } from './state'
import { getSentryDsn } from '../env'
import { insertLogoInConsentIfWhitelabel } from '../consentbar/consent-bar'
import { getLocale } from '../i18n/locale'

document.documentElement.lang = getLocale()

const currentTheme = (domain: string) => {
  if (domain.includes('mobilesyrup.planhub.ca')) {
    return theme.mobilesyrup
  } else if (domain.includes('ratehub.planhub.ca')) {
    return theme.ratehub
  } else if (domain.includes('francoischarron.planhub.ca')) {
    return theme.francoischarron
  } else if (domain.includes('protegezvous.planhub.ca')) {
    return theme.protegezvous
  } else if (domain.includes('lactualite.planhub.ca')) {
    return theme.lactualite
  } else if (domain.includes('redflagdeals.planhub.ca')) {
    return theme.redflagdeals
  } else {
    return theme.default
  }
}

const domain = window.location.hostname

insertLogoInConsentIfWhitelabel()

Sentry.init({
  dsn: getSentryDsn(),
  integrations: [new Integrations.BrowserTracing()],

  tracesSampleRate: 1.0,
})

export const bootstrap = (App: FC) => {
  render(
    <React.StrictMode>
      <ReduxProvider store={store}>
        <ChakraProvider theme={currentTheme(domain)}>
          <ColorModeScript initialColorMode={theme.default.config.initialColorMode} />
          <App />
        </ChakraProvider>
      </ReduxProvider>
    </React.StrictMode>,
    document.getElementById('root'),
  )
}
